import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// ID class for this module
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.quotes.views.QuoteListView.';
  public static readonly quoteNumberTitle = `${Id.prefix}quoteNumberTitle`;
  public static readonly titleTitle = `${Id.prefix}titleTitle`;
  public static readonly descriptionTitle = `${Id.prefix}descriptionTitle`;
  public static readonly clientTitle = `${Id.prefix}clientTitle`;
  public static readonly createdByTitle = `${Id.prefix}createdByTitle`;
  public static readonly modifiedTitle = `${Id.prefix}modifiedTitle`;
  public static readonly grossTotalTitle = `${Id.prefix}grossTotalTitle`;
  public static readonly netTotalTitle = `${Id.prefix}netTotalTitle`;
  public static readonly createQuote = `${Id.prefix}createQuote`;
  public static readonly allQuotes = `${Id.prefix}allQuotes`;
  public static readonly draft = `${Id.prefix}draft`;
  public static readonly accepted = `${Id.prefix}accepted`;
  public static readonly active = `${Id.prefix}active`;
  public static readonly issued = `${Id.prefix}issued`;
  public static readonly rejected = `${Id.prefix}rejected`;
}

// Lang wrapper for this module
export class LangQuoteListView {
  private constructor() {}
  public static quoteNumberTitle(): string {
    return interpolate(Id.quoteNumberTitle);
  }
  public static titleTitle(): string {
    return interpolate(Id.titleTitle);
  }
  public static descriptionTitle(): string {
    return interpolate(Id.descriptionTitle);
  }
  public static clientTitle(): string {
    return interpolate(Id.clientTitle);
  }
  public static createdByTitle(): string {
    return interpolate(Id.createdByTitle);
  }
  public static modifiedTitle(): string {
    return interpolate(Id.modifiedTitle);
  }
  public static grossTotalTitle(): string {
    return interpolate(Id.grossTotalTitle);
  }
  public static netTotalTitle(): string {
    return interpolate(Id.netTotalTitle);
  }
  public static createQuote(): string {
    return interpolate(Id.createQuote);
  }
  public static allQuotes(): string {
    return interpolate(Id.allQuotes);
  }
  public static draft(): string {
    return interpolate(Id.draft);
  }
  public static accepted(): string {
    return interpolate(Id.accepted);
  }
  public static active(): string {
    return interpolate(Id.active);
  }
  public static issued(): string {
    return interpolate(Id.issued);
  }
  public static rejected(): string {
    return interpolate(Id.rejected);
  }
}

// Registration module
export class QuoteListViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Table Columns
    register.add(Id.quoteNumberTitle, "{{glossary 'quote'}} No.", 'Column title for quote number');
    register.add(Id.titleTitle, 'Title', 'Column title for quote title');
    register.add(Id.descriptionTitle, 'Description', 'Column title for quote description');
    register.add(Id.clientTitle, '"{{glossary \'client\'}}"', 'Column title for client');
    register.add(Id.createdByTitle, 'Created By', 'Column title for created by');
    register.add(Id.modifiedTitle, 'Modified', 'Column title for modified date');
    register.add(Id.grossTotalTitle, 'Gross Total', 'Column title for gross total');
    register.add(Id.netTotalTitle, 'Net Total', 'Column title for net total');
    // Page Control
    register.add(Id.createQuote, "Create {{glossary 'quote'}}", 'Button to create a new quote');
    // Tabs
    register.add(Id.allQuotes, "All {{glossary 'quote':plural}}", 'Tab for all quotes');
    register.add(Id.draft, 'Draft', 'Tab for draft quotes');
    register.add(Id.accepted, 'Accepted', 'Tab for accepted quotes');
    register.add(Id.active, 'Active', 'Tab for active quotes');
    register.add(Id.issued, 'Issued', 'Tab for issued quotes');
    register.add(Id.rejected, 'Rejected', 'Tab for rejected quotes');
  }
}
